import { Component, OnInit } from '@angular/core';
import { SearchLocationsService } from '../../shared/service/search-locations.service';
import { ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';
import { IpLookupService } from '../../shared/service/ip-lookup.service';
import { UrlDecider } from '../../shared/lib/url-decider';

@Component({
  selector: 'app-search-results',
  templateUrl: './search-results.component.html',
  styleUrls: ['./search-results.component.css']
})

export class SearchResultsComponent implements OnInit {

  searchResults: any = [];

  lang: any = {};
  langSelector = 'eng';

  tbZip: any;
  regex: any;
  result: any;
  showZipError: any;
  showNoResults: any;
  ddType: string;
  ddDistance: string;

  zip: any;
  div: any;

  ipAddress: any;

  constructor(private searchService: SearchLocationsService, private route: ActivatedRoute, private ipLookup: IpLookupService) {

    if (UrlDecider.getLangFromUrl())
      this.langSelector = UrlDecider.getLangFromUrl();

    this.zip = this.route.snapshot.paramMap.get('zip');
    this.div = this.route.snapshot.paramMap.get('div');

    if (this.zip === '') {
      this.zip = 'none';
    }

    if (this.zip !== 'none')
      this.tbZip = this.zip;
    else
      this.tbZip = '';

    if (this.div)
      this.ddType = this.div;
    else
      this.ddType = 'MRB,SMB';

    this.ddDistance = '20';
  }

  ngOnInit() {

    if (this.zip === 'none') {
      this.tbZip = '';
      this.search();
    }
    if (this.tbZip) {
      this.search();
    }

    this.loadLanguage();

    this.getIPAddress();
  }

  getIPAddress() {
    this.ipLookup.getIPAddress().subscribe((res: any) => {
      this.ipAddress = res.ip;
    });
  }

  search() {

    this.tbZip = this.tbZip.trimLeft();
    this.tbZip = this.tbZip.trimRight();
    this.tbZip = this.tbZip.replace(' ', '').replace('-', '');
    this.tbZip = this.tbZip.toUpperCase();
    if (this.tbZip.length > 6) {
      this.tbZip = this.tbZip.substring(0, 5);
    }

    this.regex = /(^\s*?[0-9]{5}\s*?$)|(^\s*?[a-zA-Z]\d{1}[a-zA-Z](\-| |)\d{1}[a-zA-Z]\d{1}\s*?$)/;

    this.result = this.regex.test(this.tbZip);
    this.showZipError = document.getElementById('showZipError');
    this.showNoResults = document.getElementById('showNoResults');
    if (!this.result) {
      this.showZipError.style.display = 'block';
      this.showNoResults.style.display = 'none';
    }

    if (this.ddType && this.result) {
      this.showZipError.style.display = 'none';

      this.searchService.getSearchLocations(this.tbZip, this.ddType, this.ddDistance, this.langSelector, this.ipAddress).pipe(first()).subscribe((data: any) => {
        this.searchResults = data;

        if (this.searchResults.length < 1) {
          this.showNoResults.style.display = 'block';
        } else {
          this.showNoResults.style.display = 'none';
        }

      });
    }
    else {
      this.showZipError.style.display = 'block';
      this.searchResults = [];
    }
  }

  loadLanguage() {
    this.searchService.GetLocationSearchLang(this.langSelector).pipe(first())
      .subscribe((langJson) => {
        this.lang = langJson;
      });
  }

}
